import React from 'react';
import { useTranslation } from 'react-i18next';
import { translateBlock } from 'i18n';
import {
    BudgetProposalT,
    BudgetVentilatedDataT,
} from 'routes/BudgetModule/config/types';
import 'routes/BudgetModule/components/BudgetProposal/shared/Grids/_commonGrid.scss';
import { styled } from '@mui/material/styles';
import { InscriptionT } from 'routes/BudgetModule/shared/entities/inscription';
import Grid from './components/Grid';
import { CreateDraftOperation } from '../../BudgetOverview/AllOperations/components/CreateDraftOperation';
import { useGetCanCreateDraftOperation } from '../helpers/hooks/getBudgetVentilatedByOperation';
import { capitalize } from 'helpers/helpers';

type Props = {
    budgetProposal: BudgetProposalT;
    ventilatedData: BudgetVentilatedDataT[];
    inscriptionsData: { columns: ResponseColumnT[]; data: InscriptionT[] };
};

const StyCreationButtonContainer = styled('div', {
    name: 'StyCreationButtonContainer',
})({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    width: '100%',
    padding: '16px 0px',
});

const BudgetVentilatedByOperation = ({
    budgetProposal,
    ventilatedData,
    inscriptionsData,
}: Props): React.ReactElement => {
    const { t } = useTranslation();
    const { data: canCreate = false } = useGetCanCreateDraftOperation({
        budgetProposalId: budgetProposal.id,
    });
    const gridTitle = t('budgetProposal.requestTableTitle', {
        ventilationBy: capitalize(
            translateBlock(`secondaryBudgetAxisElement.name`),
        ),
    });

    return (
        <>
            <div className="grid-wrapper left" style={{ height: 'auto' }}>
                <Grid
                    data={ventilatedData}
                    budgetProposal={budgetProposal}
                    gridTitle={gridTitle}
                    inscriptionsData={inscriptionsData}
                    ventilationBy="operation"
                    hideCanEditColumn
                />
            </div>
            <StyCreationButtonContainer>
                <CreateDraftOperation
                    exercice={budgetProposal.exercice}
                    disabled={!canCreate}
                    budgetBy={budgetProposal.by}
                />
            </StyCreationButtonContainer>
        </>
    );
};

export default BudgetVentilatedByOperation;
